import { connect } from 'react-redux'

import {
  fetchNextJobs,
  reorderJobs,
  getNextPageId,
  getIsFetchJobsLoading,
  getIsFetchNextJobsLoading,
} from '../../../modules/job'

const mapStateToProps = (state) => ({
  nextPageId: getNextPageId(state),
  isFetchJobsLoading: getIsFetchJobsLoading(state),
  isFetchNextJobsLoading: getIsFetchNextJobsLoading(state),
})

const mapDispatchToProps = (dispatch) => ({
  dispatchReorderJobs: (source, destination) =>
    dispatch(reorderJobs(source, destination)),
  dispatchFetchNextJobs: (sortBy, next) =>
    dispatch(fetchNextJobs.request(sortBy, next)),
})

const redux = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component)

export { redux }
